<template>
  <div>
    <FormKit
      type="hidden"
      :name="`components[${index}][component_type]`"
      :value="component.component_type"
    />
      
    <FormKit
      label="Titel"
      type="text"
      :name="`components[${index}][title]`"
      :value="modelValue.title"
      @input="(value) => update('title', value)"
    />

    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <span class="font-weight-bold">Logos</span>
      </div>

      <div>
        <button type="button" class="btn btn-primary" @click="add">Add Logo</button>
      </div>
    </div>

    <Draggable v-model="logos" handle=".drag-handle" item-key="id" :key="logosKey">
      <template #item="{ element: logo, index: logoIndex }">
        <div class="border-top py-4">
          <div class="mb-2 d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <i class="las la-grip-vertical mr-2 text-muted drag-handle" style="cursor: grab;"></i>
              <span class="font-weight-bold">Logo #{{ logoIndex + 1 }}</span>
            </div>

            <div>
              <button
                  type="button"
                  class="btn btn-danger"
                  @click="remove(logoIndex)"
              >
                  <i class="lar la-trash-alt mr-2"></i>
              </button>
            </div>
          </div>

          <FormKitImage
              label="Logo afbeelding"
              :name="`components[${index}][logos][${logoIndex}][image]`"
              v-model="logo.image"
          />

          <FormKit
              label="Tekst"
              type="text"
              :name="`components[${index}][logos][${logoIndex}][text]`"
              v-model="logo.text"
          />

          <FormKit
              label="Link"
              type="text"
              :name="`components[${index}][logos][${logoIndex}][link]`"
              v-model="logo.link"
          />
        </div>
      </template>
    </Draggable>

</div>
</template>
  
<script>
import mixin from "../mixins/component";
import Draggable from "vuedraggable";

export default {
    name: "PageLogos",
    mixins: [mixin],
    components: {
        Draggable,
    },
    data() {
        let logos = [];
        
        if (this.modelValue?.logos) {
            if (Array.isArray(this.modelValue.logos)) {
                logos = this.modelValue.logos;
            } else {
                // Handle object with numeric keys - preserve the order by sorting keys numerically
                const logoObj = this.modelValue.logos;
                const sortedKeys = Object.keys(logoObj).sort((a, b) => parseInt(a) - parseInt(b));
                logos = sortedKeys.map(key => logoObj[key]);
            }
        }

        // Ensure every logo has a unique ID for stable tracking.
        logos = logos.map(logo => ({
            ...logo,
            id: logo.id || `logo_${Date.now()}_${Math.random()}`
        }));

        return {
            logos: [...logos],
        };
    },
    computed: {
        logosKey() {
            // Force re-render when logos order changes to ensure form field names match current positions
            return this.logos.map(logo => logo.id).join('-');
        },
    },
    mounted() {
        // Ensure the logos array is initialized
        if (!this.modelValue?.logos) {
            this.update("logos", this.logos);
        }
    },
    methods: {
        add() {
            this.logos.push({
                id: `logo_${Date.now()}_${Math.random()}`,
                image: "",
                text: "",
                link: "",
            });
        },
        remove(index) {
            this.logos.splice(index, 1);
        },
    },
    watch: {
        logos: {
            deep: true,
            handler(logos) {
                this.update("logos", logos);
            },
        },
    },
};
</script>
